import * as React from "react";
import { Box, Button, Tooltip, TooltipProps } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

const ToBeStyledTooltip = ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
  );

const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    color: '#000000',
    maxWidth: '463px',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #D9D9D9',
    borderRadius: '4px'
  }));

  export interface DataFillToolTipProps {
    content: React.ComponentType<any>; 
  }

const DataFillToolTip: React.FC<DataFillToolTipProps> = ({ content: ContentComponent }) => {

    return (
        <>
        <StyledTooltip
          arrow
          placement={'top-end'}
          title={
            <Box
              width={425}
            >
              <ContentComponent />
            </Box>
          }
        >
          <Button >
            <InfoOutlinedIcon />

          </Button>
        </StyledTooltip></>
    )
}

export default DataFillToolTip;